(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9553],{

/***/ 12419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63228);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Molecules_FulfillmentSelector__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30223);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Molecules_Alert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62350);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Molecules_Confirm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68494);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26793);
/* harmony import */ var _external_configSelector__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69705);
/* harmony import */ var _hooks_is_mobile_hook__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43346);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_listeners__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25268);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _external_helpers_screenHelper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20978);
/* harmony import */ var _location_selector_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11142);
/* harmony import */ var _location_selector_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_location_selector_module_scss__WEBPACK_IMPORTED_MODULE_13__);














function LocationSelector(param) {
    let { businessInfo , hideLocationSelectorHeading =false  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_12__/* .useTranslation */ .$)();
    const isMobile = (0,_hooks_is_mobile_hook__WEBPACK_IMPORTED_MODULE_7__/* .useIsMobile */ .d)();
    const [stores, setStores] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]);
    const [orderNowLaterData, setOrderNowLaterData] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const confirmDialog = (0,_urbanpiper_engineering_meraki_components_dist_Molecules_Confirm__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const alertDialog = (0,_urbanpiper_engineering_meraki_components_dist_Molecules_Alert__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const [showLocationSelector, setShowLocationSelector] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const [userLocations, setUserLocations] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]);
    const deliveryPickupConfig = _external_configSelector__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getDeliveryPickupConfig */ .Z.getDeliveryPickupConfig();
    const [storeTimings, setStoreTimings] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({});
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    const userState = _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getUserState */ .ZP.getUserState();
    const storeState = _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getStoreState */ .ZP.getStoreState();
    const useUserState = userState.hook();
    const useStoreState = storeState.hook();
    const isLandingPage = _external_helpers_screenHelper__WEBPACK_IMPORTED_MODULE_11__/* ["default"].isLandingPage */ .Z.isLandingPage(router.pathname);
    const pastLocations = useUserState((state)=>state.pastLocations);
    const selectedStore = useStoreState((state)=>state.selectedStore);
    const openDialogAndScrollToTop = ()=>{
        setShowLocationSelector((prev)=>!prev);
        if (!isMobile && _external_helpers_screenHelper__WEBPACK_IMPORTED_MODULE_11__/* ["default"].isMenuPage */ .Z.isMenuPage(router.pathname)) {
            sessionStorage.setItem("scrolledSoFar", String(window.pageYOffset));
            setTimeout(()=>{
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "smooth"
                });
            }, 300);
        }
    };
    const defaultFulfillmentType = _external_configSelector__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getDefaultFulfilmentMode */ .Z.getDefaultFulfilmentMode();
    const fulfillmentTypes = _external_configSelector__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getFulfilmentTypes */ .Z.getFulfilmentTypes();
    const upFrontDeliveryNowLater = _external_configSelector__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getUpfrontFulfillmentTimePromptFlag */ .Z.getUpfrontFulfillmentTimePromptFlag();
    const googleApiKey = _external_configSelector__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getGoogleMapsKey */ .Z.getGoogleMapsKey();
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        const pubSub = _utils_listeners__WEBPACK_IMPORTED_MODULE_9__/* .PubSub.getInstance */ .pS.getInstance();
        const listener = pubSub.addListener(_utils_listeners__WEBPACK_IMPORTED_MODULE_9__/* .EVENTS.STORE_SELECTION_REQUIRED */ .FP.STORE_SELECTION_REQUIRED, openDialogAndScrollToTop);
        (async ()=>{
            if (_urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isUserAuthenticated */ .ZP.isUserAuthenticated() && showLocationSelector) {
                const addresses = await _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getAddresses */ .ZP.getAddresses();
                const filteredAddresses = addresses === null || addresses === void 0 ? void 0 : addresses.filter((address)=>{
                    return address.tag === "home" || address.tag === "work";
                });
                setUserLocations(filteredAddresses.map((address)=>{
                    return {
                        address: [
                            address.tag,
                            address.sub_locality
                        ].join(", "),
                        latitude: address.lat,
                        longitude: address.lng,
                        placeId: address.id,
                        tag: address.tag
                    };
                }));
            }
        })();
        return ()=>pubSub.removeListener(listener);
    }, [
        showLocationSelector
    ]);
    const onOrderNowLaterRequested = async (storeId)=>{
        setLoading(true);
        try {
            const storeDeliveryInfo = await _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getStoreDeliveryParams */ .ZP.getStoreDeliveryParams(storeId);
            setOrderNowLaterData(storeDeliveryInfo.order_now_later);
            setStoreTimings({
                opening_time: (storeDeliveryInfo === null || storeDeliveryInfo === void 0 ? void 0 : storeDeliveryInfo.opening_time) || "00:00:00",
                closing_time: (storeDeliveryInfo === null || storeDeliveryInfo === void 0 ? void 0 : storeDeliveryInfo.closing_time) || "00:00:00"
            });
        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    };
    const clearAll = ()=>{
        setLoading(false);
        //setStores([]);
        setShowLocationSelector(false);
        const scrollSoFarOffset = sessionStorage.getItem("scrolledSoFar") || 0;
        if (scrollSoFarOffset) {
            setTimeout(()=>{
                window.scrollTo({
                    top: parseInt(scrollSoFarOffset),
                    left: 0,
                    behavior: "smooth"
                });
                sessionStorage.removeItem("scrolledSoFar");
            }, 500);
        }
    };
    const onLocationSelected = async (location, ffMode)=>{
        setLoading(true);
        try {
            const eventObj = {
                address: location.address,
                latitude: location.latitude,
                longitude: location.longitude,
                placeId: location.placeId
            };
            _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* ["default"].analyticsPublish */ .ZP.analyticsPublish(_urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ANALYTICS_EVENTS.ADDRESS_SELECTED */ .dW.ADDRESS_SELECTED, eventObj);
        } catch (error) {
            console.log("AnalyticsPublish: ", _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ANALYTICS_EVENTS.ADDRESS_SELECTED */ .dW.ADDRESS_SELECTED, error);
        }
        const stores = await _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getStoresFromLatLng */ .ZP.getStoresFromLatLng(location.latitude, location.longitude, ffMode);
        /** store recently searched locations */ if ((stores === null || stores === void 0 ? void 0 : stores.length) > 0) {
            userState.addSelectedLocation(location, ffMode);
            setStores(stores);
            try {
                const eventObj1 = {
                    stores: stores,
                    location: location
                };
                _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* ["default"].analyticsPublish */ .ZP.analyticsPublish(_urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ANALYTICS_EVENTS.MULTIPLE_DELIVERY_STORES */ .dW.MULTIPLE_DELIVERY_STORES, eventObj1);
            } catch (error1) {
                console.log("AnalyticsPublish: ", _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ANALYTICS_EVENTS.MULTIPLE_DELIVERY_STORES */ .dW.MULTIPLE_DELIVERY_STORES, error1);
            }
        } else {
            setShowLocationSelector(false);
            alertDialog({
                title: t("common.noNearByStoreFoundTitle"),
                content: (businessInfo === null || businessInfo === void 0 ? void 0 : businessInfo.msg_no_stores_nearby) || t("common.noNearByStoreFound")
            });
            try {
                const eventObj2 = {
                    address: location.address,
                    latitude: location.latitude,
                    longitude: location.longitude,
                    placeId: location.placeId
                };
                _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* ["default"].analyticsPublish */ .ZP.analyticsPublish(_urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ANALYTICS_EVENTS.NO_STORES_NEARBY */ .dW.NO_STORES_NEARBY, eventObj2);
            } catch (error2) {
                console.log("AnalyticsPublish: ", _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ANALYTICS_EVENTS.NO_STORES_NEARBY */ .dW.NO_STORES_NEARBY, error2);
            }
        }
        setLoading(false);
    };
    const onStoreSelected = (storeId, location, ffMode, deliveryInfo)=>{
        const storeInfo = stores.find((store)=>store.biz_location_id === storeId);
        const storeContent = {
            id: storeId,
            storeInfo,
            ...location,
            ffMode,
            deliveryInfo
        };
        try {
            _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* ["default"].setSelectedStore */ .ZP.setSelectedStore(storeContent);
        } catch (err) {
            if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Exceptions.CART_ALREADY_EXISTS */ .XM.CART_ALREADY_EXISTS) {
                confirmDialog({
                    title: t("header.clearCartHeading"),
                    content: t("header.clearCartDescription"),
                    onConfirm: ()=>{
                        _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* ["default"].setSelectedStore */ .ZP.setSelectedStore(storeContent, true);
                    }
                });
            }
            if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Exceptions.STORE_ORDERING_NOT_ENABLED */ .XM.STORE_ORDERING_NOT_ENABLED) {
                alertDialog({
                    title: t("storeLocator.storeClosed"),
                    content: (businessInfo === null || businessInfo === void 0 ? void 0 : businessInfo.msg_nearest_store_closed) || t("storeLocator.storeClosed")
                });
            }
            if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Exceptions.STORE_TEMPORARY_CLOSED */ .XM.STORE_TEMPORARY_CLOSED) {
                alertDialog({
                    title: t("storeLocator.storeClosed"),
                    content: (businessInfo === null || businessInfo === void 0 ? void 0 : businessInfo.msg_nearest_store_closed) || t("storeLocator.storeClosed")
                });
            }
        }
    };
    const onLocationStore = ()=>{
        router.push("/store-locator");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: hideLocationSelectorHeading ? (_location_selector_module_scss__WEBPACK_IMPORTED_MODULE_13___default().locationSelectorHeadingHidden) : "",
        onClick: ()=>setShowLocationSelector(true),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Molecules_FulfillmentSelector__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            isOpen: showLocationSelector,
            fulfillmentTypes: fulfillmentTypes,
            loading: loading,
            selectedStore: selectedStore,
            onClose: clearAll,
            onLocationSelected: onLocationSelected,
            onStoreSelected: onStoreSelected,
            stores: stores,
            googleApiKey: googleApiKey,
            isMobile: isMobile,
            fulfillmentType: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.ffMode) || defaultFulfillmentType,
            pastLocations: pastLocations,
            onOrderNowLaterRequested: onOrderNowLaterRequested,
            upFrontDeliveryNowLater: upFrontDeliveryNowLater,
            orderLaterData: orderNowLaterData,
            startDate: dayjs__WEBPACK_IMPORTED_MODULE_10___default()().format("YYYY-MM-DD"),
            endDate: dayjs__WEBPACK_IMPORTED_MODULE_10___default()().add(_external_configSelector__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getMaxPreOrderDate */ .Z.getMaxPreOrderDate(), "days").format("YYYY-MM-DD"),
            userLocations: userLocations,
            isOrderNowDisabled: deliveryPickupConfig === null || deliveryPickupConfig === void 0 ? void 0 : deliveryPickupConfig.hideDeliverPickupNow,
            isOrderLaterDisabled: (deliveryPickupConfig === null || deliveryPickupConfig === void 0 ? void 0 : deliveryPickupConfig.maxPreOrderDate) === -1 || _external_configSelector__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getHideOrderingTime */ .Z.getHideOrderingTime(),
            storeTimings: storeTimings,
            onLocationStore: onLocationStore,
            searchMode: isLandingPage
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (LocationSelector);


/***/ }),

/***/ 69553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_AboutUsOne__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43106);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_AboutUsThree__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86190);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_AppPromoSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99457);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_FeaturedDishOne__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13871);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_FeaturedDishTwo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71702);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_FeaturedDishThree__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4336);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_HeroOne__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13813);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_HeroTwo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63687);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_TestimonialsOne__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44536);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_TestimonialsTwo__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91277);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_TestimonialThree__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5684);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_HeroThree__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85388);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_HowItWorksThree__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87880);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_LandingScreenMenu__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(22477);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_OurMenuSectionTwo__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(11454);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_WhyChooseUsSectionTwo__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4683);
/* harmony import */ var _external_configSelector__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69705);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(63228);
/* harmony import */ var _components_location_selector__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(12419);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_23__);


























const landingPageComponentsOrder = [
    "heroBanner",
    "aboutUs",
    "brandValues",
    "recommendedItems",
    "menuSection",
    "testimonials",
    "appPromotion"
];
function GetHeroComponent(component, variant, extras) {
    const { customizations: config  } = component;
    const { onOffersReadMoreClick  } = extras;
    const [coupons, setCoupons] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const isSearchLocationEnabled = config === null || config === void 0 ? void 0 : config.enableLocationSearch;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__/* ["default"].getCoupons */ .ZP.getCoupons().then((param)=>{
            let { coupons  } = param;
            setCoupons(coupons.splice(0, 3));
        });
    }, []);
    if (variant === "theme1") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_HeroOne__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            title: config.title,
            backgroundImage: config.backgroundImage,
            logo: config.logoUrl || _external_configSelector__WEBPACK_IMPORTED_MODULE_18__/* ["default"].getBizLogoURL */ .Z.getBizLogoURL(),
            locationSearch: isSearchLocationEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_location_selector__WEBPACK_IMPORTED_MODULE_22__["default"], {}) : null,
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    if (variant === "theme2") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_HeroTwo__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            title: config.title,
            subTitle: config.subTitle,
            rightClipBackground: config.backgroundImage,
            topBackground: _external_configSelector__WEBPACK_IMPORTED_MODULE_18__/* ["default"].getBizLogoURL */ .Z.getBizLogoURL(),
            logo: config.logoUrl || _external_configSelector__WEBPACK_IMPORTED_MODULE_18__/* ["default"].getBizLogoURL */ .Z.getBizLogoURL(),
            backgroundImage: config.backgroundImage,
            locationSearch: isSearchLocationEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_location_selector__WEBPACK_IMPORTED_MODULE_22__["default"], {}) : null,
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    if (variant === "theme3") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_HeroThree__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            title: config.title,
            subTitle: config === null || config === void 0 ? void 0 : config.subTitle,
            subTitleColor: config === null || config === void 0 ? void 0 : config.subTitleColor,
            description: config.description,
            featuredImage: config.featuredImage,
            mobileFeaturedImage: config.mobileFeaturedImage,
            backgroundImage: config.backgroundImage,
            offers: coupons,
            logoImage: config.logoUrl || _external_configSelector__WEBPACK_IMPORTED_MODULE_18__/* ["default"].getBizLogoURL */ .Z.getBizLogoURL(),
            locationSearch: isSearchLocationEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_location_selector__WEBPACK_IMPORTED_MODULE_22__["default"], {}) : null,
            onOffersReadMoreClick: onOffersReadMoreClick,
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}
const getAboutUsComponent = (component, variant)=>{
    const { customizations: config  } = component;
    const ctaURL = config === null || config === void 0 ? void 0 : config.ctaUrl;
    if (variant === "theme1") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_AboutUsOne__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            title: config.title,
            description: config.description,
            image: config.image,
            onReadMoreClick: ()=>{
                window.open(ctaURL, "_blank");
            },
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    if (variant === "theme2") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_AboutUsThree__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            onKnowMoreClick: ()=>{
                window.open(ctaURL, "_blank");
            },
            firstImage: config.image,
            secondImage: config.imageTwo,
            ...config,
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
function GetRecommendedItems(component, variant, extras) {
    const { customizations: config  } = component;
    if (variant === "theme2") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_FeaturedDishTwo__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            title: config.title,
            description: config.description,
            onOrderNowClick: ()=>{
                window.open(config === null || config === void 0 ? void 0 : config.ctaUrl, "_blank");
            },
            image: config === null || config === void 0 ? void 0 : config.featuredDishImage,
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    if (variant === "theme3") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_FeaturedDishThree__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            title: config.title,
            description: config.description,
            onOrderNowClick: ()=>{
                window.open(config === null || config === void 0 ? void 0 : config.ctaUrl, "_blank");
            },
            image: config === null || config === void 0 ? void 0 : config.featuredDishImage,
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}
const getAppPromotion = (component)=>{
    const { customizations: config  } = component;
    const onAndroidClick = ()=>{
        window.open(config.androidAppUrl, "_blank");
    };
    const onIOSClick = ()=>{
        window.open(config.iosAppUrl, "_blank");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_AppPromoSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        onAndroidClick: onAndroidClick,
        onIOSClick: onIOSClick,
        ...config,
        imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
    });
};
const getTesimonials = (component, variant)=>{
    const { customizations: config  } = component;
    if (variant === "theme1") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_TestimonialsOne__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            testimonials: config.values.map((e)=>({
                    name: e.author_name,
                    designation: e.author_position,
                    quote: e.content,
                    image: e.author_img
                })),
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    if (variant === "theme2") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_TestimonialsTwo__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            testimonials: config.values.map((e)=>({
                    name: e.author_name,
                    designation: e.author_position,
                    quote: e.content,
                    image: e.author_img
                })),
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    if (variant === "theme3") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_TestimonialThree__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            testimonials: config.values.map((e)=>({
                    name: e.author_name,
                    designation: e.author_position,
                    quote: e.content,
                    image: e.author_img
                })),
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
function GetMenuSection(component, variant, extras) {
    const { customizations: config  } = component;
    const { onViewMenuClickCallback , onItemClickCallback , menuSectionDisplayNumber  } = extras;
    const [items, setItems] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const dataTransformCategoriesForLandingScreen = (categories)=>{
        return categories.map((category)=>{
            let tempCat = category;
            tempCat.item_title = category.name;
            tempCat.image_url = category.image;
            tempCat.item_desc = category.description;
            return tempCat;
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (config.mode === "categories") {
            _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__/* ["default"].getCategories */ .ZP.getCategories().then((categories)=>{
                const transformedCategories = dataTransformCategoriesForLandingScreen(categories);
                if (menuSectionDisplayNumber === "showAll") {
                    setItems(transformedCategories);
                } else {
                    setItems(transformedCategories.splice(0, 6));
                }
            });
        } else if (config.mode === "items") {
            _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__/* ["default"].getRecommendedItems */ .ZP.getRecommendedItems().then((catalogue)=>{
                setItems(catalogue.splice(0, 6));
            });
        }
    }, [
        config
    ]);
    if (variant === "theme1") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_FeaturedDishOne__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            description: config.description,
            items: items,
            onItemClickCallback: onItemClickCallback,
            viewMoreClickCallback: onViewMenuClickCallback,
            backgroundImage: config.backgroundImage,
            title: config.title,
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    if (variant === "theme2") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_OurMenuSectionTwo__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            onViewMenuClick: onViewMenuClickCallback,
            onItemClickCallback: (item)=>onItemClickCallback(item, config.mode),
            description: config === null || config === void 0 ? void 0 : config.description,
            title: config === null || config === void 0 ? void 0 : config.title,
            items: items,
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    if (variant === "theme3") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_LandingScreenMenu__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            menu: items,
            onViewMenuClick: onViewMenuClickCallback,
            onItemClick: (item)=>onItemClickCallback(item, config.mode),
            description: config === null || config === void 0 ? void 0 : config.description,
            title: config === null || config === void 0 ? void 0 : config.title,
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}
const getLandingPageComponent = (component, theme, extras)=>{
    var _component_customizations;
    if (component === null || component === void 0 ? void 0 : (_component_customizations = component.customizations) === null || _component_customizations === void 0 ? void 0 : _component_customizations.enabled) {
        switch(component._id){
            case "heroBanner":
                return GetHeroComponent(component, theme, extras);
            case "aboutUs":
                return getAboutUsComponent(component, theme);
            case "brandValues":
                return getWhyChooseUsComponent(component, theme);
            case "appPromotion":
                return getAppPromotion(component);
            case "testimonials":
                return getTesimonials(component, theme);
            case "recommendedItems":
                return GetRecommendedItems(component, theme, extras);
            case "menuSection":
                return GetMenuSection(component, theme, extras);
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
        }
    }
};
const getWhyChooseUsComponent = (component, variant)=>{
    const { customizations: config  } = component;
    if (variant === "theme2") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_WhyChooseUsSectionTwo__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            onReadMore: ()=>{
                window.open(config === null || config === void 0 ? void 0 : config.readMoreCtaUrl, "_blank");
            },
            title: config === null || config === void 0 ? void 0 : config.title,
            desc: config === null || config === void 0 ? void 0 : config.description,
            values: (config === null || config === void 0 ? void 0 : config.values) || [],
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    if (variant === "theme1" || variant === "theme3") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_HowItWorksThree__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            ...config,
            imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_23___default())
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
function LandingPage(param) {
    let { landingPageConfig , variant , seoConfig  } = param;
    var _componentsConfig_find, _componentsConfig_find_customizations;
    const theme = variant || landingPageConfig.variant;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_20__.useRouter)();
    const componentsConfig = (landingPageConfig === null || landingPageConfig === void 0 ? void 0 : landingPageConfig.components) || [];
    const sortedComponents = [];
    landingPageComponentsOrder.forEach((component)=>{
        const componentConfig = componentsConfig.find((comp)=>comp._id === component);
        if (componentConfig) {
            sortedComponents.push(componentConfig);
        }
    });
    try {
        _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__/* ["default"].analyticsPublish */ .ZP.analyticsPublish(_urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__/* .ANALYTICS_EVENTS */ .dW === null || _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__/* .ANALYTICS_EVENTS */ .dW === void 0 ? void 0 : _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__/* .ANALYTICS_EVENTS.LANDING_SCREEN_OPEN */ .dW.LANDING_SCREEN_OPEN, {
            theme: landingPageConfig === null || landingPageConfig === void 0 ? void 0 : landingPageConfig.variant
        });
    } catch (err) {
        console.log("AnalyticsPublish: ", _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__/* .ANALYTICS_EVENTS */ .dW === null || _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__/* .ANALYTICS_EVENTS */ .dW === void 0 ? void 0 : _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__/* .ANALYTICS_EVENTS.LANDING_SCREEN_OPEN */ .dW.LANDING_SCREEN_OPEN, err);
    }
    const onViewMenuClickCallback = ()=>{
        try {
            const eventObj = {
                variant: landingPageConfig === null || landingPageConfig === void 0 ? void 0 : landingPageConfig.variant,
                page_source: "landing_page"
            };
            _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__/* ["default"].analyticsPublish */ .ZP.analyticsPublish(_urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__/* .ANALYTICS_EVENTS.VIEW_MENU_CLICKED */ .dW.VIEW_MENU_CLICKED, eventObj);
        } catch (error) {
            console.log("AnalyticsPublish: ", _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_21__/* .ANALYTICS_EVENTS.VIEW_MENU_CLICKED */ .dW.VIEW_MENU_CLICKED, error);
        }
        router.push("/menu");
    };
    const onItemClickCallback = (item, menuSectionMode)=>{
        if (menuSectionMode === "categories") {
            router.push("category/".concat(item.id, "/").concat(item === null || item === void 0 ? void 0 : item.slug));
        } else {
            router.push("/item-list/".concat(item.id, "/").concat(item === null || item === void 0 ? void 0 : item.slug));
        }
    };
    const onOffersReadMoreClick = ()=>{
        router.push("/offers");
    };
    let menuSectionDisplayNumber = ((_componentsConfig_find = componentsConfig.find((component)=>component._id === "menuSection")) === null || _componentsConfig_find === void 0 ? void 0 : (_componentsConfig_find_customizations = _componentsConfig_find.customizations) === null || _componentsConfig_find_customizations === void 0 ? void 0 : _componentsConfig_find_customizations.displayNumber) || "default";
    const extras = {
        onViewMenuClickCallback,
        onItemClickCallback,
        onOffersReadMoreClick,
        menuSectionDisplayNumber
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_19___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: seoConfig === null || seoConfig === void 0 ? void 0 : seoConfig.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: seoConfig === null || seoConfig === void 0 ? void 0 : seoConfig.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: seoConfig === null || seoConfig === void 0 ? void 0 : seoConfig.keywords
                    })
                ]
            }),
            sortedComponents.map((component)=>getLandingPageComponent(component, theme, extras))
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (LandingPage);


/***/ }),

/***/ 11142:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"locationSelectorHeadingHidden":"location_selector_locationSelectorHeadingHidden__w3tto"};

/***/ })

}]);